import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import classNames from 'classnames';

type Props = {
  className?: string,
  classes: any
};

const MyTextField = ({ className, classes, ...rest }: Props) => {
  return (
    <TextField
      className={classNames(classes.root, className)}
      InputLabelProps={{ shrink: true }}
      inputProps={{ size: 1 }}
      margin="normal"
      fullWidth
      {...rest}
    />
  );
};

const styles = (/*{ spacing: { unit: spacing } }*/) => ({
  root: {}
});

export default withStyles(styles)(MyTextField);
